module.exports = __webpack_public_path__ + "static/media/5a.d9752fc9.jpg";